// extracted by mini-css-extract-plugin
export default {"body":"PhMhr3","buttons":"WdAKlu","button":"xiWa6Z","conversion":"xMEvRd","socialButton":"_4Vgtu"};